import { createApp } from 'vue'
import router from '../routes/index'
import store from '../store/index'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueLoading from 'vue-loading-overlay'
import Adjust from '@adjustcom/adjust-web-sdk'
import "./assets/reset.css"
import toast from '@/components/common/toast.js'
import App from '@/App.vue'
import './registerServiceWorker'
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
let adjust_referrer = getParameterByName("adjust_referrer")
Adjust.initSdk({
    appToken: '97n44culr9j4',
    environment: 'production',
    logLevel:"verbose",
});  
try {
    Adjust.setReferrer(encodeURIComponent(`${adjust_referrer}`)) 
    // console.log(adjust_referrer)  
} catch (error) {
    console.log(error)
}

console.log(window.location.href)
let app = createApp(App)
app.config.globalProperties.$toast = toast
app.use(router).use(store).use(VueLoading)
app.provide('$toast', toast)
app.mount('#app')
store.dispatch("fetchConfig")